export enum MsgType {
    TEXT = "text",
    FILE = "file"
}

//类型：0教师、1学生
export enum ReceiverType {
    Teacher = "0",
    Student = "1"
}

//类型：0正常 1撤回 2举报
export enum OperatorTypeType {
    Normal = "0",
    Retract = "1",
    Report = "2"
}

export interface TextMessageItem {
    guid: string; //消息guid
    sessionUid: string; //会话guid
    sender: ChatConfereesItem; //发送人信息
    sendDate: string; //发送时间
    courseNo?: string; //关联课程编号
    courseSeq?: string; //关联课程序号
    batchNo?: string; //学期编号
    customerCode?: string; //用户代码
    operatorType: string; //操作类型：0正常显示操作、1撤回操作
    deleteNoTypes?: string; //删除人标识
    content: string; //消息内容
    type: MsgType; //消息类型：text：文本   file：文件
    delStatus: string; //删除标识符（0否1是）
    isAccused?: BooleanValue; // 是否被举报
    error?: string; // 错误信息
}

export interface FileMessageItem extends TextMessageItem {
    percent?: number;
    uploading?: boolean; // 正在上传或发送
}

export type ChatMessageItem = TextMessageItem | FileMessageItem;

export interface FileContent {
    filename: string;
    url: string;
    filesize: number;
    type: string;
}

export interface ChatConfereesItem {
    no: string; //参与人编号
    name: string; //参与人姓名
    type: ReceiverType; //参与人类型0教师、1学生
    chatStatus?: string; //打开状态：0否1是
}

export interface SessionListItem {
    sessionTopic: string; //会话标题
    guid: string; //会话guid
    chatConferees: ChatConfereesItem[]; //会话参与人列表
    chatConfereesNoTypeListStr: string; //参会者编号以及类型列表， 用,号隔开
    notReadNoTypeList?: string[]; //还未读取的用户编号+"-"+用户类型（0教师、1学生）
    sessionType: string; //会话类型：0一对一会话、1群聊会话
    hasMsg: string; //是否存在消息：0否1是
    lastSessionTime: string; //最后会话时间
    chatMessages: ChatMessageItem[]; //消息记录
}

export interface SimpleSessionItem {
    guid: string; //会话guid
    userNo: string;
    sessionTopic: string; //会话标题
    lastSessionTime: string; //最后会话时间
    lastMsgContent: string; //最后会话内容
    hasNewMessage?: boolean; //有未读消息
}

export interface CourseListItem {
    key: string;
    batchNo: string; //课程所属学期
    courseName: string; //课程名称
    courseNo: string; //课程编号
    customerCode: string; //用户代码
    courseSeq: string; //课程序号
}

export interface Files {
    fileName: string;
    filePercent: number;
    fileSize: string;
    fileState: "uploading" | "done" | "error" | "pending" | "stop";
    fileType: string;
    fileUrl: string;
    uid: string;
}

// 发送反馈
export interface FeedbackItem {
    sessionId: string;
    messageId: string;
    success: BooleanValue;
    errorMessage: string;
}
